module.exports = __webpack_public_path__ + "static/media/Specialized-Nutrition.901d7fc0.png";